import { ConflictError, fieldErrors } from "@/api/client";
import { Alert } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { capitalise } from "@/lib/format";

/**
 * Explains a failed request. A stale-version conflict offers Reload; 422 field messages are
 * shown next to their fields by the form, so only the form-level message appears here.
 */
export function RequestError({ error, onReload }: { error: unknown; onReload?: () => void }) {
  if (!error) return null;

  if (error instanceof ConflictError && error.isStale) {
    return (
      <Alert
        variant="warning"
        title="This record was changed by someone else"
        action={
          onReload ? (
            <Button size="sm" variant="outline" onClick={onReload}>
              Reload
            </Button>
          ) : undefined
        }
      >
        Reload to get the latest version, then make your change again.
      </Alert>
    );
  }

  const formMessage = fieldErrors(error)._form;
  const message =
    formMessage ?? (error instanceof Error ? error.message : "Something went wrong. Please try again.");
  return <Alert variant="error">{capitalise(message)}</Alert>;
}
